<template>
  <div class="content">
    <v-app-bar
      v-if="!isDialog"
      color="grey lighten-3"
      class="caption"
      flat
      dense
    >
      <v-btn @click="$router.go(-1)" color="grey darken-1" dark depressed small>
        <v-icon class="mr-1" small>mdi-chevron-left</v-icon>
        返回
      </v-btn>
      <v-spacer></v-spacer>
      <div v-if="hasItem" :class="'text-truncate' + (!isDialog ? ' ml-2' : '')">
        <v-chip color="white" label small>
          {{ utils.formatTime(item.addDate, "date") }}
        </v-chip>
      </div>
    </v-app-bar>
    <v-card tile flat>
      <v-card-title class="body-1">
        {{ item.title }}
        <template v-if="isDialog">
          <v-spacer></v-spacer>
          <v-btn @click="fnClose" icon small>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-card-title>
      <v-card-subtitle
        v-if="showChannel"
        @click="$router.push(`/contents?channelId=${item.channelId}`)"
      >
        {{ item.channelName }}
      </v-card-subtitle>
      <v-card-text v-if="showAuthor" class="py-1 grey lighten-2">
        <div v-if="item.author" class="d-flex align-start text-truncate">
          <v-icon class="mr-1 mt-1" small>mdi-account-edit</v-icon>
          <v-chip-group column>
            <v-chip
              v-for="(chip, index) in utils.setArray(item.author, ' ')"
              :key="index"
              @click="$router.push(`/users?author=${chip}`)"
              color="transparent"
              class="px-0 my-0"
              label
              small
            >
              {{ chip }}
            </v-chip>
          </v-chip-group>
        </div>
        <div v-if="item.source" class="d-flex align-start text-truncate">
          <v-icon class="mr-1 mt-1" small>mdi-account-group</v-icon>
          <v-chip-group column>
            <v-chip
              v-for="(chip, index) in utils.setArray(item.source, ' ')"
              :key="index"
              color="transparent"
              class="px-0 my-0"
              label
              small
            >
              {{ chip }}
            </v-chip>
          </v-chip-group>
        </div>
      </v-card-text>
      <v-img
        v-if="!!item.imageUrl"
        :src="utils.checkFile(item.imageUrl)"
        class="white--text"
        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.2)"
        contain
      >
      </v-img>
      <v-card-text
        v-if="!!item.body"
        id="content"
        class="content"
        v-html="utils.checkBody(item.body)"
      >
      </v-card-text>
      <v-card-text v-if="!!item.fileUrl" class="pt-0">
        <v-btn
          :href="utils.checkFile(item.fileUrl)"
          target="_blank"
          block
          depressed
        >
          附件下载
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// 自定义功能
import utils from "@/utils";
export default {
  name: "CContent",
  props: {
    item: { type: Object, required: false, default: () => {} },
    isDialog: { type: Boolean, required: false, default: false },
    // showAuthor: { type: Boolean, required: false, default: true },
  },
  components: {},
  data: () => ({
    utils: utils,
    hasItem: false,
    showChannel: false,
  }),
  watch: {
    item(val) {
      this.showChannel = !!val.channelName;
      this.$nextTick(() => {
        this.setBodyStyle();
      });
    },
  },
  computed: {
    showAuthor() {
      return !this.isDialog;
    },
  },
  mounted() {
    if (this.item) this.hasItem = true;
    if (this.item.channelName) this.showChannel = true;
    this.$nextTick(() => {
      this.setBodyStyle();
    });
  },
  methods: {
    setBodyStyle() {
      var arr = document.querySelectorAll(".content table");
      arr.forEach((item) => {
        var htmlStr = `<div class="v-data-table v-data-table--dense theme--light" file="v-simple-table/prop-dense"><div class="v-data-table__wrapper"><table>${item.innerHTML}</table></div></div>`;
        item.outerHTML = htmlStr;
      });
      arr = document.querySelectorAll(".content p");
      arr.forEach((item) => {
        if (item.innerHTML.indexOf("<img") != -1) {
          item.className = "text-center";
        } else {
          item.className = "text-indent";
        }
      });
    },
    fnClose() {
      this.$emit("dialogShow", false);
    },
  },
};
</script>
<style lang="scss">
.v-slide-group__content {
  padding: 0 !important;
}
.text-indent {
  text-indent: 2em;
}
</style>